import http from '../clients/Axios'

export default class PelangganService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          filters_param =
            filters_param + '&filter[' + el + ']=' + filters[el].value
        }
      })
    }

    const res = await http.get(
      `/pelanggan/paginate?page[number]=${pageNumber}&page[size]=${pageSize}&sort=${sort}${filters_param}`
    )

    return res.data
  }

  async get(param) {
    param = param ? param : ''
    const res = await http.get(`/pelanggan${param}`)
    return res
  }

  async add(form) {
    return await http.post('/pelanggan', form)
  }

  async update(form) {
    return await http.put(`/pelanggan/${form.id}`, form)
  }

  async delete(id) {
    return await http.delete(`/pelanggan/${id}`)
  }

  async downloadFormSpesimen() {
    return http({
      url: '/pelanggan/spesimen',
      method: 'GET',
      responseType: 'blob',
    })
  }

  async upload(id, field, value) {
    let formData = new FormData()

    if (value) {
      formData.append(field, value)
    }

    return await http.post(`/pelanggan/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  async export(sortField, sortOrder, filters) {
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          filters_param =
            filters_param + '&filter[' + el + ']=' + filters[el].value
        }
      })
    }

    const unixTime = Math.floor(Date.now() / 1000)
    return http({
      url: `/pelanggan/export?sort=${sort}${filters_param}&t=${unixTime}`,
      method: 'GET',
      responseType: 'blob',
    })
  }
}
